import styled from '@emotion/styled';
import { motion } from 'framer-motion';
export const SettingsWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  pointer-events: none;
`;
export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;
export const ModalContent = styled(motion.div)`
  background: white;
  
  .dark & {
    background: #1f2937;
  }
  
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 90%;
  max-width: 700px;
  height: 80vh;
  max-height: 800px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  @media (max-width: 640px) {
    width: 95%;
    height: 90vh;
    border-radius: 0.75rem;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  
  .dark & {
    border-bottom: 1px solid #374151;
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
    
    .dark & {
      color: #f9fafb;
    }
  }
`;
export const ServerList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    
    .dark & {
      background: #374151;
    }
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
    
    .dark & {
      background: #4b5563;
    }

    &:hover {
      background: #9ca3af;
      
      .dark & {
        background: #6b7280;
      }
    }
  }
`;
export const ServerItem = styled(motion.div)`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  margin: 0.25rem;
  border-radius: 0.75rem;
  background-color: #f9fafb;
  border: 1px solid transparent;
  transition: all 0.2s;
  
  .dark & {
    background-color: #374151;
  }

  &:hover {
    background-color: #f3f4f6;
    border-color: #e5e7eb;
    
    .dark & {
      background-color: #4b5563;
      border-color: #374151;
    }
  }
`;
export const ServerStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 0.5rem;
  background-color: #e5e7eb;
  flex-shrink: 0;
  
  .dark & {
    background-color: #4b5563;
  }
`;
export const ServerInfo = styled.div`
  flex: 1;
  overflow: hidden;

  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    
    .dark & {
      color: #f9fafb;
    }
  }

  .url {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0 0 0.25rem 0;
    font-family: monospace;
    
    .dark & {
      color: #9ca3af;
    }
  }

  .description {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0.25rem 0;
    
    .dark & {
      color: #9ca3af;
    }
  }

  .error {
    font-size: 0.875rem;
    color: #ef4444;
    margin: 0.25rem 0;
  }

  .capabilities {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-top: 0.5rem;
  }

  .capability {
    display: inline-block;
    padding: 0.125rem 0.5rem;
    font-size: 0.75rem;
    background-color: #dbeafe;
    color: #1e40af;
    border-radius: 9999px;
    
    .dark & {
      background-color: #1e3a8a;
      color: #93c5fd;
    }
  }
`;
export const ServerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`;
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #9ca3af;
  gap: 1rem;
  padding: 2rem;

  svg {
    color: #d1d5db;
  }

  p {
    font-size: 1rem;
    margin: 0;
  }
`;
export const AddServerForm = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;

  h3 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 1.5rem 0;
    
    .dark & {
      color: #f9fafb;
    }
  }
`;
export const FormGroup = styled.div`
  margin-bottom: 1.25rem;
`;
export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
  
  .dark & {
    color: #d1d5db;
  }
`;
export const Input = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid ${({ error })=>error ? '#ef4444' : '#d1d5db'};
  border-radius: 0.5rem;
  background-color: white;
  color: #111827;
  transition: all 0.2s;
  
  .dark & {
    background-color: #374151;
    border-color: ${({ error })=>error ? '#ef4444' : '#4b5563'};
    color: #f9fafb;
  }

  &:focus {
    outline: none;
    border-color: ${({ error })=>error ? '#ef4444' : '#3b82f6'};
    box-shadow: 0 0 0 3px ${({ error })=>error ? 'rgba(239, 68, 68, 0.1)' : 'rgba(59, 130, 246, 0.1)'};
  }

  &::placeholder {
    color: #9ca3af;
  }
`;
export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background-color: white;
  color: #111827;
  transition: all 0.2s;
  resize: vertical;
  
  .dark & {
    background-color: #374151;
    border-color: #4b5563;
    color: #f9fafb;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;
export const ErrorMessage = styled.span`
  display: block;
  font-size: 0.75rem;
  color: #ef4444;
  margin-top: 0.25rem;
`;
export const TabNavigation = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  
  .dark & {
    border-bottom: 1px solid #374151;
  }

  button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem 1.5rem;
    border: none;
    background: transparent;
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border-bottom: 2px solid transparent;
    
    .dark & {
      color: #9ca3af;
    }
    
    &:hover {
      color: #374151;
      background: #f9fafb;
      
      .dark & {
        color: #d1d5db;
        background: #4b5563;
      }
    }
    
    &.active {
      color: #3b82f6;
      border-bottom-color: #3b82f6;
      background: #f8fafc;
      
      .dark & {
        color: #60a5fa;
        background: #1e293b;
      }
    }
  }
`;
export const TabContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
